export default __webpack_public_path__ + "static/media/FeelingWheel.fadedd50.svg";